module.exports = __webpack_public_path__ + "static/media/pgn-logo.dece4b69.png";